// react
import React, {useEffect, useMemo, useState} from 'react'
// antd-pro
import {ModalForm, ProFormSelect, ProFormText} from '@ant-design/pro-components'
// components
import HwhtFormItems from './hwht'
import HoseFormItems from '@/pages/itg/add/hose'
// api
import Api from '@/api'
// enum
import {AppType} from '@/enum'
import {Button, message, Spin} from 'antd'
// util
import {IsManagerPro} from '@/utils'
import EsignFormItems from './esign'
import FeiShuFormItems from './feishu'
import SqlFormItems from './database'
import DataBaseFormItems from './database'
import KingDeeFormItems from './kingdee'
import DingTalkFormItems from './dingtalk'
import JSTFormItems from './jst'
import ZJZFormItems from './zjz'
import ETEAMSFormItems from './eteams'
import YUNZJFormItems from './yunzj'
import BeiSenFormItems from './beisen'
import QIYUESUOFormItems from './qiyuesuo'
import NuoNuoFormItems from './nuonuo'
import HSDianDangItems from './hsdiandang'
import SeeyonFormItems from './seeyon'
import SeeyonEhrFormItems from './seeyonehr'
import DidiFormItems from './didi'
import WangShangFormItems from './wangshang'
import XRXSFormItems from './xrxs'
import GBZCFormItems from './gongbeizichan'
import XIAOSHOUYIFormItems from './xiaoshouyi'
import HosePayFormItems from './hosepay'
import OracleDataBaseFormItems from './oracleDB'
import FxxkFormItems from './fxxk'
import SAASQIYUESUOFormItems from './saasqiyuesuo'
import KingDeeClientFormItems from './kd_client'


interface IProps {
  close: (reload?: boolean) => void
  en?: any
  appTypes?: AppType[]
  readonly?: boolean
  corpId?: string
}

/**
 * 编辑app的添加
 * @constructor
 */
const EditAppModal = (props: IProps) => {

  const [AppTypeVal, setAppTypeVal] = useState<AppType>()
  const [Loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (props.en) {
      setAppTypeVal(props.en.appType)
    }
  }, [props.en])

  /**
   * 表单信息
   */
  const itemsDom = useMemo(() => {
    switch (AppTypeVal) {
      case AppType.FEISHU:
        return <FeiShuFormItems/>
      case AppType.ESIGN:
        return <EsignFormItems/>
      case AppType.HWHT:
        return <HwhtFormItems/>
      case AppType.HOSE:
        return <HoseFormItems/>
      case AppType.DATABASE:
        return <DataBaseFormItems/>
      case AppType.KINGDEE:
        return <KingDeeFormItems/>
      case AppType.DINGTALK:
        return <DingTalkFormItems/>
      case AppType.JST:
        return <JSTFormItems/>
      case AppType.ZJZ:
        return <ZJZFormItems/>
      case AppType.ETEAMS:
        return <ETEAMSFormItems/>
      case AppType.YUNZJ:
        return <YUNZJFormItems/>
      case AppType.BEISEN:
        return <BeiSenFormItems/>
      case AppType.QIYUESUO:
        return <QIYUESUOFormItems/>
      case AppType.SAAS_QIYUESUO:
        return <SAASQIYUESUOFormItems/>
      case AppType.NUONUO:
        return <NuoNuoFormItems/>
      case AppType.DIANDANG:
        return <HSDianDangItems/>
      case AppType.SEEYON:
        return <SeeyonFormItems/>
      case AppType.SEEYON_EHR:
        return <SeeyonEhrFormItems/>
      case AppType.DIDI:
        return <DidiFormItems/>
      case AppType.WANGSHANGBANK:
        return <WangShangFormItems/>
      case AppType.XRXS:
        return <XRXSFormItems/>
      case AppType.GBZC:
        return <GBZCFormItems/>
      case AppType.XSY:
        return <XIAOSHOUYIFormItems/>
      case AppType.HOSE_EKB_PAY:
        return <HosePayFormItems/>
      case AppType.ORACLE_DATABASE:
        return <OracleDataBaseFormItems/>
      case AppType.FXXK:
        return <FxxkFormItems/>
      case AppType.KINGDEE_CLIENT:
        return <KingDeeClientFormItems/>
      default:
        return <></>
    }
  }, [AppTypeVal])

  /**
   * 保存信息
   * @param values
   */
  const submitInfo = async (values: any) => {
    values.id = props.en.id
    values.appId = values.appId.split('_')[0]
    values.appType = values.appId.split('_')[1]
    if (IsManagerPro) {
      values.corpId = props.corpId
    }
    setLoading(true)
    const _data = await Api.App.AppSave(values).finally(() => setLoading(false))
    if (_data) {
      message.success("保存成功！")
      props.close(true)
    }
  }

  const titleName = () => {
    if (props.en) {
      if (props.readonly) {
        return "应用详情"
      }
      return "修改应用"
    }
    return "添加应用"
  }

  return (
    <ModalForm
      open={true}
      title={titleName()}
      width={600}
      layout={"horizontal"}
      labelAlign={"right"}
      labelCol={{span: 5}}
      wrapperCol={{span: 17}}
      initialValues={props.en && {
        ...props.en,
        appId: props.en.appId + "_" + props.en.appType,
        config: JSON.parse(props.en.config)
      }}
      modalProps={{
        onCancel: () => props.close(),
        maskClosable: false
      }}
      onFinish={submitInfo}
      loading={Loading}
      readonly={props.readonly}
      submitter={!props.readonly ? {
        render: (subProps) => {
          return [
            <Button
              key="rest"
              onClick={() => props.close(false)}
            >
              取消
            </Button>,
            <Button
              type="primary"
              key="submit"
              onClick={() => subProps.form?.submit?.()}
            >
              保存
            </Button>,
          ]
        },
      } : false}
    >
      <Spin spinning={Loading}>
        <ProFormText name={"state"} hidden initialValue={"0"}/>
        <ProFormSelect
          label={"应用"}
          name={"appId"}
          width={"lg"}
          placeholder={"请选择应用"}
          readonly={props.en}
          request={async () => {
            const _data: any = await Api.Common.AppList({})
            _data.forEach((item: any) => {
              item.label = item.appName
              item.value = item.appId + '_' + item.appType
              if (props.appTypes?.includes(item.appType) && !props.en) {
                item.label = item.appName + "(已配置)"
                item.disabled = true
              }
            })
            return _data
          }}
          onChange={(value: string) => {
            setAppTypeVal(value.split('_')[1] as AppType)
          }}
          required
          rules={[
            {
              required: true,
              message: "请选择应用"
            }
          ]}
        />
        {itemsDom}
      </Spin>
    </ModalForm>
  )
}

export default EditAppModal
